import * as Yup from "yup";

export const signupSchema = Yup.object({
    name:Yup.string().min(2).max(25).required("Name is required."),
    email:Yup.string().email().required("Valid email is required."),
    subject:Yup.string().min(5).max(20).required("Subject is required."),
    phone:Yup.number().min(1000000000 , "Not valid phone number!").max(9999999999,"Not a valid phone number!").required("Phone is required."),
    message:Yup.string().min(5).max(100).required("Please,leave us a message.")

})